import React, { } from 'react';
import PropTypes from 'prop-types';
import CaseItemLink from './CaseItemLink';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {
      //width: '100%',
    //   maxWidth: 230,
      //float:'left'
    },
  });

//   useEffect(() => {
//     console.log('CaseItemLinkList mounted');
//     console.log(this.statecaseItems)
// }, [this.state.caseItems]);


// const CaseItemLinkList = (props) => {
class CaseItemLinkList extends React.Component {

    render() {
        const { classes, caseItems, context, history, match } = this.props;

        console.log('CaseItemLinkList caseItems: ', caseItems);
        if (caseItems == undefined) {
            return (
                <div className={classes.divStyle}>

                </div>
            );
        }
        else if (caseItems.length == 0) {
            if (localStorage.getItem('typeOfAccount') == 'arbitrator') {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
            else if (localStorage.getItem('typeOfAccount') == 'admin') {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
            else {
                return (
                    <div className={classes.divStyle}>
                        <h4 className={classes.paper}> {context.t('There is no case in this account.')} </h4>
                    </div>
                );
            }
        }
        else {

            if (caseItems.length == 1) {
                history.push(`${match.path}/${caseItems[0].caseId}`);
            }

            return (
                <div className={classes.root}>
                    <Grid container direction="row" alignItems="center" >
                        {
                            caseItems.sort((a, b) => a.caseId - b.caseId).map((title, index) => (
                                <React.Fragment key={index}>
                                    <CaseItemLink primary={title} />
                                </React.Fragment>
                            ))
                        }
                    </Grid>
                </div>
            );
        }
    }
}

CaseItemLinkList.contextTypes = {
  t: PropTypes.func
}
export default withStyles(styles)(withRouter(CaseItemLinkList));